import { usePermissions } from 'react-admin';
import { PlatformRole, type PlatformRole as PlatformRoleValue } from './roles';

/**
 * True when the signed-in principal holds `platform:superadmin` — the role the
 * API reserves for the writes that mint, replace or narrow access itself:
 * gateway credential material, creating or modifying the gateway account that
 * decides which provider and which mode a hotel's money moves through, and the
 * whole API-credential lifecycle.
 *
 * Reads are never gated on this. The vault has no read path at all — no
 * endpoint returns a decrypted credential to anybody — so what this separates
 * is not who can *see* a hotel's signing key but who can *replace* it and point
 * its takings at a different merchant. That is the only place on this surface
 * where the blast radius is money rather than data, which is why it is the only
 * place with its own role.
 *
 * Deliberately an exact-role check, exactly like {@link useCanWrite}: a
 * principal holding `platform:superadmin` also holds `platform:admin` because
 * the access provider's mapping expands it, not because any guard treats the
 * roles as a hierarchy.
 */
export function useCanManageAccess(): boolean {
  const { permissions } = usePermissions<PlatformRoleValue[]>();
  if (!permissions) return false;
  return permissions.includes(PlatformRole.SuperAdmin);
}
